module.exports = __webpack_public_path__ + "static/media/curriculum_theme_light.7fabaedd.svg";